// ============================================================================
// FSA PARTNER MASTER ENDPOINTS (NCP-13)
// ============================================================================

import { buildEndpoint } from '../base.endpoints';

export const PARTNERS_BASE = '/FsaPartners';

export const fsaPartnerEndpoints = {
  list:   () => buildEndpoint(PARTNERS_BASE),
  byId:   (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
  create: () => buildEndpoint(PARTNERS_BASE),
  update: (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
  remove: (id: string | number) => buildEndpoint(`${PARTNERS_BASE}/${id}`),
};
